<template>
    <section class="pt-8">
        <!--<h3 class="text-lg lg:text-xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-4">
            Notifications
        </h3>-->
        <ul class="w-full">
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="general-marketing-pref"
                >
                    <span class="font-semibold">General Notifications</span>
                    <div class="text-sm">
                        Stay up to date with tips, updates, timely deals and
                        My10x product updates.
                    </div>
                </label>
                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="
                            updatePreference('pref_allow_general_marketing')
                        "
                        :class="{
                            'bg-orange':
                                preferences.pref_allow_general_marketing,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_general_marketing,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="privacy-option-1-label"
                        aria-describedby="privacy-option-1-description"
                    >
                        <input
                            type="checkbox"
                            id="general-marketing-pref"
                            class="hidden"
                            v-model="preferences.pref_allow_general_marketing"
                            name="pref_allow_general_marketing"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_general_marketing,
                                'translate-x-0':
                                    !preferences.pref_allow_general_marketing,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_general_marketing,
                                'opacity-0':
                                    !preferences.pref_allow_general_marketing,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="changelog-notice"
                >
                    <span class="font-semibold">Change Log Notifications</span>
                    <div class="text-sm">
                        Stay up to date with My10x application features.
                    </div>
                </label>
                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="updatePreference('pref_allow_changelog_notice')"
                        :class="{
                            'bg-orange':
                                preferences.pref_allow_changelog_notice,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_changelog_notice,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="privacy-option-1-label"
                        aria-describedby="privacy-option-1-description"
                    >
                        <input
                            type="checkbox"
                            id="changelog-notice"
                            class="hidden"
                            v-model="preferences.pref_allow_changelog_notice"
                            name="pref_allow_general_marketing"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_changelog_notice,
                                'translate-x-0':
                                    !preferences.pref_allow_changelog_notice,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_changelog_notice,
                                'opacity-0':
                                    !preferences.pref_allow_changelog_notice,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
        </ul>
    </section>

    <section class="pt-8">
        <div class="grid grid-cols-12 gap-4 mb-5">
            <h3
                class="col-span-6 text-lg lg:text-xl leading-snug text-gray-800 dark:text-gray-100 dark:text-slate-100 font-bold mb-4"
            >
                Alerts & Reports
            </h3>
            <div class="col-span-6 flex justify-end">
                <label class="flex items-center">
                    <span class="text-xs">Toggle All</span>
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="setToggleAll()"
                        :class="{
                            'bg-navy-400': toggleAll,
                            'bg-gray-200 dark:bg-slate-600': !toggleAll,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="privacy-option-1-label"
                        aria-describedby="privacy-option-1-description"
                    >
                        <input
                            type="checkbox"
                            id="toggle-all"
                            class="hidden"
                            v-model="toggleAll"
                            name="toggle_all"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5': toggleAll,
                                'translate-x-0': !toggleAll,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-navy-400 absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300': toggleAll,
                                'opacity-0': !toggleAll,
                            }"
                        ></i>
                    </button>
                </label>
            </div>
        </div>
        <ul class="w-full">
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="general-alerts-pref"
                >
                    <span class="font-semibold">Account Reminders</span>
                    <div class="text-sm">
                        Stay one step ahead by receiving important reminders,
                        personalized based on your My10X account, such as
                        upcoming annual fees, eligibility for new cards,
                        updating your credit score and more.
                    </div>
                </label>

                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="updatePreference('pref_allow_general_alerts')"
                        :class="{
                            'bg-orange': preferences.pref_allow_general_alerts,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_general_alerts,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="general-alerts-pref-label"
                        aria-describedby="general-alerts-pref-description"
                    >
                        <input
                            type="checkbox"
                            id="general-alerts-pref"
                            class="hidden"
                            v-model="preferences.pref_allow_general_alerts"
                            name="pref_allow_general_alerts"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_general_alerts,
                                'translate-x-0':
                                    !preferences.pref_allow_general_alerts,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_general_alerts,
                                'opacity-0':
                                    !preferences.pref_allow_general_alerts,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="general-alerts-pref"
                >
                    <span class="font-semibold">Credit Score Reminders</span>
                    <div class="text-sm">
                        Receive reminders for when it's time to update your
                        credit score.
                    </div>
                </label>

                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="
                            updatePreference(
                                'pref_allow_credit_score_notice_to_update'
                            )
                        "
                        :class="{
                            'bg-orange':
                                preferences.pref_allow_credit_score_notice_to_update,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_credit_score_notice_to_update,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="general-alerts-pref-label"
                        aria-describedby="general-alerts-pref-description"
                    >
                        <input
                            type="checkbox"
                            id="creditscore-alerts-pref"
                            class="hidden"
                            v-model="
                                preferences.pref_allow_credit_score_notice_to_update
                            "
                            name="pref_allow_credit_score_notice_to_update"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_credit_score_notice_to_update,
                                'translate-x-0':
                                    !preferences.pref_allow_credit_score_notice_to_update,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_credit_score_notice_to_update,
                                'opacity-0':
                                    !preferences.pref_allow_credit_score_notice_to_update,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="general-alerts-pref"
                >
                    <span class="font-semibold">
                        Loyalty Program Balance Reminders
                    </span>
                    <div class="text-sm">
                        Receive reminders for when it's time to update your
                        loyalty program balances.
                    </div>
                </label>

                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="
                            updatePreference(
                                'pref_allow_rewards_notice_to_update'
                            )
                        "
                        :class="{
                            'bg-orange':
                                preferences.pref_allow_rewards_notice_to_update,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_rewards_notice_to_update,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="general-alerts-pref-label"
                        aria-describedby="general-alerts-pref-description"
                    >
                        <input
                            type="checkbox"
                            id="points-alerts-pref"
                            class="hidden"
                            v-model="
                                preferences.pref_allow_rewards_notice_to_update
                            "
                            name="pref_allow_rewards_notice_to_update"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_rewards_notice_to_update,
                                'translate-x-0':
                                    !preferences.pref_allow_rewards_notice_to_update,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_rewards_notice_to_update,
                                'opacity-0':
                                    !preferences.pref_allow_rewards_notice_to_update,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="general-alerts-pref"
                >
                    <span class="font-semibold">
                        Minimum Spend Deadline Reminders
                    </span>
                    <div class="text-sm">
                        We'll help ensure you've met your minimum spend
                        deadlines with a helpful reminder 30 days out.
                    </div>
                </label>

                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="
                            updatePreference('pref_allow_sub_notice_to_update')
                        "
                        :class="{
                            'bg-orange':
                                preferences.pref_allow_sub_notice_to_update,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_sub_notice_to_update,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="general-alerts-pref-label"
                        aria-describedby="general-alerts-pref-description"
                    >
                        <input
                            type="checkbox"
                            id="subdeadline-alerts-pref"
                            class="hidden"
                            v-model="
                                preferences.pref_allow_sub_notice_to_update
                            "
                            name="pref_allow_sub_notice_to_update"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_sub_notice_to_update,
                                'translate-x-0':
                                    !preferences.pref_allow_sub_notice_to_update,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_sub_notice_to_update,
                                'opacity-0':
                                    !preferences.pref_allow_sub_notice_to_update,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
            <!--
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b dark:border-slate-700 items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="monthly-reporting-pref"
                >
                    <span class="font-semibold">Monthly Reports</span>
                    <div class="text-sm">
                        Receive a personalized monthly summary of your My10x
                        account including changes in your point balances, 5/24
                        count and more.
                    </div>
                </label>
                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="updatePreference('pref_allow_monthly_reports')"
                        :class="{
                            'bg-orange': preferences.pref_allow_monthly_reports,
                            'bg-gray-200 dark:bg-slate-600':
                                !preferences.pref_allow_monthly_reports,
                        }"
                        role="switch"
                        aria-checked="true"
                        aria-labelledby="privacy-option-1-label"
                        aria-describedby="privacy-option-1-description"
                    >
                        <input
                            type="checkbox"
                            id="general-reporting-pref"
                            class="hidden"
                            v-model="preferences.pref_allow_monthly_reports"
                            name="pref_allow_monthly_reports"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_monthly_reports,
                                'translate-x-0':
                                    !preferences.pref_allow_monthly_reports,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_monthly_reports,
                                'opacity-0':
                                    !preferences.pref_allow_monthly_reports,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
            -->
        </ul>
    </section>

    <section v-if="hasActiveAccess" class="pt-8">
        <div class="grid grid-cols-12 gap-4 mb-5">
            <h3
                class="col-span-12 text-lg lg:text-xl leading-snug text-gray-800 dark:text-slate-100 font-bold mb-1"
            >
                10xTravel+
            </h3>
            <p class="col-span-12 text-sm text-gray-500 dark:text-slate-400 -mt-4">
                Preferences for 10xTravel+ subscribers.
            </p>
        </div>
        <ul class="w-full">
            <li class="grid grid-cols-12 gap-4 mb-4 pb-4 border-b items-center">
                <label
                    class="col-span-8 flex flex-col items-start"
                    for="benefits-reminder-pref"
                >
                    <span class="font-semibold">
                        Benefits Tracking Reminders
                    </span>
                    <div class="text-sm">
                        Receive email reminders about card benefits that are
                        expiring soon so you don't leave money on the table.
                    </div>
                </label>

                <div class="col-span-4 text-right">
                    <button
                        type="button"
                        class="relative ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                        @click="
                            updatePreference('pref_allow_benefits_reminder')
                        "
                        :class="{
                            'bg-orange':
                                preferences.pref_allow_benefits_reminder,
                            'bg-gray-200':
                                !preferences.pref_allow_benefits_reminder,
                        }"
                        role="switch"
                        :aria-checked="
                            preferences.pref_allow_benefits_reminder
                                ? 'true'
                                : 'false'
                        "
                        aria-labelledby="benefits-reminder-pref-label"
                        aria-describedby="benefits-reminder-pref-description"
                    >
                        <input
                            type="checkbox"
                            id="benefits-reminder-pref"
                            class="hidden"
                            v-model="preferences.pref_allow_benefits_reminder"
                            name="pref_allow_benefits_reminder"
                            value="1"
                        />
                        <span
                            aria-hidden="true"
                            class="inline-block h-5 w-5 transform rounded-full bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 ring-0 transition duration-200 ease-in-out"
                            :class="{
                                'translate-x-5':
                                    preferences.pref_allow_benefits_reminder,
                                'translate-x-0':
                                    !preferences.pref_allow_benefits_reminder,
                            }"
                        ></span>
                        <i
                            class="fa-solid fa-check fa-xs text-orange absolute top-2.5 right-1 transition"
                            :class="{
                                'opacity-100 delay-300':
                                    preferences.pref_allow_benefits_reminder,
                                'opacity-0':
                                    !preferences.pref_allow_benefits_reminder,
                            }"
                        ></i>
                    </button>
                </div>
            </li>
        </ul>
    </section>
</template>
<script>
import { handleError } from '@/utils/error-handler';

export default {
    name: 'NotificationToggles',
    props: {
        hasActiveAccess: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        preferences: {
            pref_allow_general_alerts: false,
            pref_allow_general_marketing: false,
            pref_allow_monthly_reports: false,
            pref_allow_changelog_notice: false,
            pref_allow_credit_score_notice_to_update: false,
            pref_allow_rewards_notice_to_update: false,
            pref_allow_sub_notice_to_update: false,
            pref_allow_benefits_reminder: true,
        },
        pToken: null,
        toggleAll: true,
    }),
    methods: {
        getNotificationPreferences() {
            ApiService.apiCall(
                '/user-settings/get-notification-preferences',
                'get'
            )
                .then((response) => {
                    this.preferences = response.data.preferences;
                })
                .catch((response) => {
                    handleError(response);
                });
        },
        updatePreference(prefName, ignoreLocalToggle = false) {
            if (!ignoreLocalToggle) {
                this.preferences[prefName] = !this.preferences[prefName];
            }
            ApiService.apiCall(
                '/user-settings/notification-preferences/' + prefName,
                'put',
                { prefValue: this.preferences[prefName] }
            )
                .then((response) => {})
                .catch((response) => {
                    handleError(response);
                });
        },
        setToggleAll() {
            this.toggleAll = !this.toggleAll;

            Object.entries(this.preferences).forEach((entry) => {
                const [key, value] = entry;
                if (
                    key !== 'pref_allow_changelog_notice' &&
                    key !== 'pref_allow_general_marketing' &&
                    key !== 'pref_allow_benefits_reminder'
                ) {
                    this.preferences[key] = this.toggleAll;
                    setTimeout(() => {
                        this.updatePreference(key, true);
                    }, 500);
                }
            });
        },
    },
    mounted() {
        this.getNotificationPreferences();
    },
};
</script>
